"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../pageloadEventCreators/factory");
var utils_1 = require("../../utils");
var globalEventCreators_1 = require("../../globalEventCreators");
var screenloadHander = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.ScreenLoad || context.isHandled) {
        return;
    }
    // don't reset the queue if the caller says not to do so (default is to reset the queue):
    var loadOptions = event.eventData;
    var resetDataLayer = !(loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.doNotResetDataLayer);
    if (resetDataLayer) {
        (0, analytics_layer_1.resetEventQueue)();
        (0, utils_1.resetEventQueue)();
    }
    // main:
    if (event.eventName != analytics_layer_1.ScreenLoadEventNames.PureScreenLoad) {
        var mainEventData = (0, factory_1.getCreator)(event.eventName)(event);
        (0, utils_1.pushEvent)(mainEventData);
    }
    // login:
    if (event.loggedInUser) {
        var loginEvent = (0, globalEventCreators_1.createLoginEvent)(event);
        (0, utils_1.pushEvent)(loginEvent);
    }
    //screenload:
    if ((loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.suppressGenericLoad) !== true) {
        var screenload = (0, globalEventCreators_1.createScreenloadEvent)(event);
        (0, utils_1.pushEvent)(screenload);
    }
    // ab:
    if (event.ab) {
        var abEvent = (0, globalEventCreators_1.createAbImpressionEvent)(event);
        (0, utils_1.pushEvent)(abEvent);
    }
    context.isHandled = true;
};
exports.default = screenloadHander;
